// This file was auto-generated by Fern from our API Definition.
export const SimpleTraceOrigin = {
    Custom: "custom",
    Human: "human",
    Auto: "auto",
};
